import type { DependsOnState } from '@ns/plugin-picker-shared';

function valueOf(
  state: DependsOnState,
  ref: string | undefined,
): Record<string, unknown> | undefined {
  if (state.kind !== 'ready' || ref === undefined) return undefined;
  const value = state.values[ref];
  if (typeof value !== 'object' || value === null) return undefined;
  return { ...value };
}

/**
 * The subscription id from the field `subscriptionRef` points at.
 *
 * @remarks
 * `subscriptionId` is the bare GUID and `id` the full path. Resource Graph's
 * `subscriptions` argument takes the GUID, so that is what is read.
 */
export function subscriptionIdFrom(
  state: DependsOnState,
  ref: string | undefined,
): string | undefined {
  const value = valueOf(state, ref)?.subscriptionId;
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/**
 * The resource-group NAME from the field `resourceGroupRef` points at.
 *
 * @remarks
 * The name and not the id, because the query compares against the
 * `resourceGroup` column, which holds the name.
 */
export function resourceGroupNameFrom(
  state: DependsOnState,
  ref: string | undefined,
): string | undefined {
  const value = valueOf(state, ref)?.name;
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}
